import { Button, Container, Divider, Grid, useMediaQuery } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import FlexView from 'react-flexview/lib'
import { FirebaseConfigKey, FirebaseService } from '../../../services/FirebaseService'
import { SkyPaper } from '../../Core/Frames/SkyPaper'
import { ReactComponent as VMark } from '../../../assets/V_circle_purple.svg'
import { ReactComponent as XMark } from '../../../assets/X_circle_purple.svg'
import './NewCoveragePlanCard.scss'
import { FlatOutlinedButton } from '../../Core/Buttons/FlatOutlinedButton'
import SimpleAccordion from '../../Core/Expansion/SimpleAccordion'
import { SkyInformationPopover } from '../../Core/Popover/SkyPopover'
import { CoveragePlanCardSlider } from './CoveragePlanCardSlider'
import { SessionContextStore } from '../../../context/SessionContext'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import EditIcon from '@material-ui/icons/Edit'
import { useHistory } from 'react-router-dom'
import { reportGTM } from '../../Core/Utilities/GTagManger'
import { PAYMENT_FEE } from '../../../Constants'

const PlanPrice = ({ isMobile, isHighlighted, getVehicles }) => {
  let color = isHighlighted ? 'white' : 'secondaryblack'

  const getPlanTotalPrice = () => {
    const vehiclesList = getVehicles()
    let totalPrice = 0
    vehiclesList.forEach(vehicle => {
      totalPrice += vehicle.fixedPrice + (vehicle.perMilePrice * vehicle.estimatedMileage) / 12
    })

    return totalPrice
  }

  if (isMobile)
    return (
      <div>
        <FlexView vAlignContent={'top'} hAlignContent={'center'} column>
          <FlexView>
            <span className={`text-promotion x-bolder ${color}`}>{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}</span>
            <span className={`text-promotion x-bolder ${color}`} style={{ fontSize: 40 }}>
              {Math.ceil(getPlanTotalPrice() + PAYMENT_FEE).toLocaleString()}
            </span>
          </FlexView>
          <div className="text-tiny" style={{ marginTop: '-5px' }}>
            Monthly
          </div>
        </FlexView>
      </div>
    )
  else
    return (
      <div className="textcenter margin-bottom-small">
        <FlexView vAlignContent={'top'} hAlignContent={'center'} column>
          <div className={`plan-price text-promotion  x-bolder secondaryblack`}>
            {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
            {Math.ceil(getPlanTotalPrice() + PAYMENT_FEE).toLocaleString()}
          </div>
          <div className="text-tiny" style={{ marginTop: '-5px' }}>
            Monthly
          </div>
        </FlexView>
      </div>
    )
}

const FeatureLine = ({ feature, isHighlighted = false }) => {
  let isBool = val => {
    return val == 'true' || val == 'false'
  }
  return (
    <>
      <FlexView className="space-between full-width margin-top-basic margin-bottom-basic" vAlignContent={'center'}>
        <FlexView vAlignContent={'center'} hAlignContent={'left'}>
          <FlexView shrink={0}>
            {feature.included == 'yes' && <VMark className="margin-right-3" />}
            {feature.included == 'no' && <XMark className="margin-right-3" />}
          </FlexView>
          <FlexView>
            <div className={`text-secondary gray font-style-title`}>
              {feature.title}
              {feature.tooltip && (
                <SkyInformationPopover style={{ fontSize: '0.9rem', marginLeft: 0 }}>
                  <div className="text-small">{feature.tooltip}</div>
                </SkyInformationPopover>
              )}
            </div>
          </FlexView>
        </FlexView>
        <FlexView vAlignContent={'center'} hAlignContent={'right'}>
          {feature.subtitle && !isBool(feature.subtitle) && <div className={`text-small gray font-style-subtitle`}>{feature.subtitle}</div>}
        </FlexView>
      </FlexView>
    </>
  )
}

export const NewCoveragePlanCard = ({ plan, onClick, isHighlighted }) => {
  const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'))
  const [isSliderOpen, setSliderOpen] = useState(false)
  const sessionContext = useContext(SessionContextStore)
  const offersContext = useContext(BuyingInsuranceContextStore)
  const history = useHistory()

  const getVehiclesDetails = () => {
    const vehiclesPlan = plan.vehicleCoveragePrices
    const vehiclesDetails = sessionContext.user.userVehicles
    const vehiclesList = []
    for (const vehicleId in vehiclesPlan) {
      const requestedVehicle = vehiclesDetails.filter(v => v.id == vehicleId)[0]
      if (requestedVehicle != undefined) {
        vehiclesList.push({
          year: requestedVehicle.year,
          make: requestedVehicle.make,
          model: requestedVehicle.model,
          estimatedMileage: requestedVehicle.estimated_mileage_value,
          fixedPrice: vehiclesPlan[vehicleId].fixedPrice,
          perMilePrice: vehiclesPlan[vehicleId].perMilePrice,
        })
      }
    }
    return vehiclesList
  }

  const closeSlider = () => setSliderOpen(false)

  const openSlider = () => {
    setSliderOpen(true)
    reportGTM('', '', { event: 'Calculate-total' })
  }

  const choosePlanAndNavToEditPlan = () => {
    offersContext.choosePlan(plan)
    reportGTM('', '', { event: 'Edit-plan-coverages' })
    history.push(`/insurance/summary`, { editMode: true })
  }
  const getPlanCoverages = plan => {
    const allCoverages = [...plan.coverages, ...Object.values(plan.vehicleCoverages)[0]]
    allCoverages.sort((valueA, valueB) => {
      const isIncludeA = valueA.included === 'yes'
      const isIncludeB = valueB.included === 'yes'

      if (isIncludeA === isIncludeB) {
        return 0
      } else if (isIncludeA) {
        return -1
      } else {
        return 1
      }
    })

    return allCoverages.filter(feature => !feature.is_hidden)
  }

  return (
    <Container maxWidth="xs">
      <SkyPaper isHighlighted={isHighlighted} className={`card-style ${isMobile && isHighlighted ? 'margin-top-large' : ''}`}>
        {isHighlighted && <div className={`floating-label text-title textcenter white bolder`}>Our Best Price</div>}
        {isMobile && (
          <>
            <Grid container spacing={1}>
              <Grid item xs={9}>
                <div className={`text-title bolder blue`}>{plan.label}</div>
                <div className="text-small bold backbuttongray">{plan.subLabel}</div>
              </Grid>
              <Grid item xs={3}>
                <PlanPrice
                  isMobile={isMobile}
                  value={plan.fixedPrice}
                  perMile={plan.perMileCharge}
                  per={plan.period}
                  getVehicles={getVehiclesDetails}
                />
              </Grid>
            </Grid>
            <Divider className="blue" />
            {!isSliderOpen ? (
              <div onClick={openSlider} className={`text-small underline clickable blue`}>
                Pay per mile calculation
              </div>
            ) : (
              <CoveragePlanCardSlider
                onClose={closeSlider}
                perMileRate={plan.perMileCharge}
                baseRate={plan.fixedPrice}
                vehiclesDetails={sessionContext.user.userVehicles}
                getVehicles={getVehiclesDetails}
                affiliateCode={sessionContext.user.affiliateCode}
              />
            )}
            <FlexView hAlignContent="center">
              <FlatOutlinedButton
                onClick={onClick}
                className="margin-top-small text-small blue-bold-button"
                style={{ fontSize: 12 }}
                color="primary"
                fullWidth={true}
                textBold={true}
                variant={isHighlighted ? 'contained' : 'outlined'}
              >
                EXPLORE PLAN
              </FlatOutlinedButton>
            </FlexView>
            <SimpleAccordion
              className="margin-top-small transperent"
              title={<div className={`text-small white underline blue`}>More details</div>}
              content={
                <div style={{ width: '100%' }}>
                  <FlexView hAlignContent={'right'}>
                    <div onClick={choosePlanAndNavToEditPlan} className={`text-small underline clickable blue`}>
                      <EditIcon style={{ fontSize: 20 }} />
                      Edit limits
                    </div>
                  </FlexView>
                  {plan.coverages
                    .filter(feature => !feature.isHidden)
                    .map((feature, index) => (
                      <FeatureLine key={index} feature={feature} isHighlighted={isHighlighted} />
                    ))}
                </div>
              }
            />
          </>
        )}

        {!isMobile && (
          <>
            <Grid container spacing={1}>
              <Grid item xs={9}>
                <FlexView className={'space-between blue'} vAlignContent={'center'} column>
                  <div>
                    <div className="text-title bolder">{plan.label}</div>
                    <div className={`text-small margin-top-3 black`}>{plan.subLabel}</div>
                  </div>
                </FlexView>
              </Grid>
              <Grid item xs={3}>
                <FlexView vAlignContent="top" column>
                  <PlanPrice value={plan.fixedPrice} perMile={plan.perMileCharge} per={plan.period} getVehicles={getVehiclesDetails} />
                </FlexView>
              </Grid>
            </Grid>
            <Divider className="blue" />

            {!isSliderOpen ? (
              <div onClick={openSlider} className={`text-small underline clickable blue`}>
                Pay per mile calculation
              </div>
            ) : (
              <CoveragePlanCardSlider
                onClose={closeSlider}
                perMileRate={plan.perMileCharge}
                baseRate={plan.fixedPrice}
                vehiclesDetails={sessionContext.user.userVehicles}
                getVehicles={getVehiclesDetails}
                affiliateCode={sessionContext.user.affiliateCode}
              />
            )}

            <FlexView hAlignContent={'center'}>
              <FlatOutlinedButton onClick={onClick} fullWidth={true} unFilledHover={true}>
                EXPLORE PLAN
              </FlatOutlinedButton>
            </FlexView>
            <FlexView hAlignContent={'right'}>
              <div onClick={choosePlanAndNavToEditPlan} className={`text-small underline clickable blue`}>
                <EditIcon style={{ fontSize: 20 }} />
                Edit plan
              </div>
            </FlexView>

            {getPlanCoverages(plan).map((feature, index) => (
              <FeatureLine key={index} feature={feature} /*isHighlighted={isHighlighted}*/ />
            ))}
          </>
        )}
      </SkyPaper>
    </Container>
  )
}
